import React, { ReactElement } from 'react';
import styled from 'styled-components';
// Components
import { ContextAwareCart, SavedProductList, SidebarNav } from 'components';
import jbtOfficialLogo from '../../icons/img/OmniBlu Official Logo.svg';
import { JBTMarelCrossLogo } from 'icons/indexed-icons/JBTMarelCrossLogo';
import TextBadge from '../BadgeWithText/TextBadge';
import breakpoint from 'constants/breakpoints';
import DropdownSelect from '../DropdownMenu/DropdownSelect';
import { useUser } from 'selectors';
import { JBTRoutes } from 'constants/routes';
import { useHistory } from 'react-router-dom';
import { FleetNavigationProvider } from 'providers';
import { Role, SidenavItemProps } from 'types';
import Notification from 'components/Notifications/index';
import { HeaderProvider } from './HeaderContext';
interface HeaderProps {
  items: SidenavItemProps[];
  role?: Role.Admin | Role.User;
}

const OuterHeaderContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  height: 60px;
  align-items: center;
  position: sticky;
  top: 0px;
  z-index: 990;
  padding-left: 15px;
  background: linear-gradient(180deg, #014182 7.8%, #0199ee 112.59%);
`;
const InnerLogoContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: center;
`;
const ImgContainer = styled.div`
  padding-top: 3px;
  width: 60%;
  cursor: pointer;
`;
const Divider = styled.div`
  width: 1px;
  height: 28px;
  background-color: #e5e9ed;
`;
const IconContainer = styled.div`
  display: flex;
  gap: 25px;
  justify-content: flex-end;
  padding-right: 15px;
  align-items: center;
`;
const InnerContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  @media ${breakpoint.device.md} {
    width: 26%;
  }
`;
const IconInnerContainer = styled.div`
  display: flex;
  gap: 25px;
  align-items: center;
  @media (max-width: 540px) {
    display: none;
  }
`;

const SidebarNavMobile = styled.div`
  @media (min-width: 541px) {
    display: none;
  }
`;

const Header = ({ role, items }: HeaderProps): ReactElement => {
  const headerColor = import.meta.env.VITE_HEADER_COLOR;
  const user = useUser();
  const history = useHistory();

  return (
    <HeaderProvider>
      <OuterHeaderContainer style={{ backgroundColor: headerColor }}>
        <InnerContainer>
          <SidebarNavMobile>
            <FleetNavigationProvider>
              <SidebarNav items={items} role={role} mobileView={true} />
            </FleetNavigationProvider>
          </SidebarNavMobile>
          <InnerLogoContainer>
            <JBTMarelCrossLogo />
            <Divider></Divider>
            <ImgContainer
              onClick={() => {
                history.push(JBTRoutes.dashboard);
              }}
            >
              <img src={jbtOfficialLogo} alt="jbtLogo" />
            </ImgContainer>
          </InnerLogoContainer>
        </InnerContainer>

        <IconContainer>
          <IconInnerContainer>
            <DropdownSelect />
            <SavedProductList />
          </IconInnerContainer>
          <ContextAwareCart />
          {import.meta.env.VITE_ENABLE_CALCULATED_TAGS_TAB === 'true' && <Notification />}
          <TextBadge name={`${user?.firstName} ${user?.lastName}`} />
        </IconContainer>
      </OuterHeaderContainer>
    </HeaderProvider>
  );
};

export default Header;
